// Foreground selection wins over pagination. Background work waits for an
// existing foreground request and never aborts it or adds another active fetch.
const createBoardAthleteRequestLanes = () => {
  const active = { foreground: null, hydration: null };

  const finish = (request) => {
    if (active[request.lane] === request) active[request.lane] = null;
    request.complete();
  };
  const cancel = (lane) => {
    const request = active[lane];
    if (!request) return;
    request.controller.abort();
    finish(request);
  };
  const cancelAll = () => {
    cancel("hydration");
    cancel("foreground");
  };
  const begin = (lane = "foreground") => {
    if (lane !== "hydration") lane = "foreground";
    if (lane === "foreground") cancelAll();
    else cancel("hydration");

    let complete;
    const done = new Promise((resolve) => { complete = resolve; });
    const request = { lane, controller: new AbortController(), done, complete };
    const foreground = active.foreground;
    request.ready = foreground
      ? Promise.race([foreground.done, done]).then(() => !request.controller.signal.aborted)
      : Promise.resolve(true);
    active[lane] = request;
    return request;
  };

  return {
    begin,
    finish,
    cancelAll,
    cancelHydration: () => cancel("hydration"),
    hasForeground: () => Boolean(active.foreground),
  };
};

module.exports = { createBoardAthleteRequestLanes };
